
import { defineMessages } from 'react-intl';

const scope = 'app.services.exportService';
export default defineMessages({
  checkReport: {
    id: `${scope}.checkReport`,
    defaultMessage: 'Check for errors',
  },
  reportFailed: {
    id: `${scope}.reportFailed`,
    defaultMessage: 'Report generation failed.',
  },
  reportDownloaded: {
    id: `${scope}.reportDownloaded`,
    defaultMessage: 'Report downloaded.',
  },
  generatingReport: {
    id: `${scope}.reportFailed`,
    defaultMessage: 'Generating report : ',
  },
});
